<template><!-- 更新モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol class="scr">
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>更新内容確認</strong></a>
              <CCardText><strong>以下の内容で更新してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>会社名</strong></a><br>
                  {{ company_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ telephone }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>定時前打刻猶予時間</strong></a><br>
                  {{ pre_buffer }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>定時後打刻猶予時間</strong></a><br>
                  {{ post_buffer }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>定時後打刻猶予時間を休憩とする</strong></a><br>
                  {{ post_work_break_flg ? 'はい' : 'いいえ' }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>勤務時間の最小単位</strong></a><br>
                  {{ work_time_unit }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>規定定時間</strong></a><br>
                  {{ work_basic }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>規定休憩時間</strong></a><br>
                  {{ break_basic }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>プロジェクト設定の休憩時間を自動設定する</strong></a><br>
                  {{ use_project_break_flg ? 'はい' : 'いいえ' }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>規定定時間</strong></a><br>
                  {{ slack_token }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>規定定時間</strong></a><br>
                  {{ slack_channel }}
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol>
            <button @click="$emit('close')" class="btn btn-secondary">キャンセル</button>
          </CCol>
          <CCol  class="update-button-col">
            <save-button
              :label="'更新'"
              :loading="loading"
              class="btn btn-primary"
              @click="$emit('update')"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'UpdateModal',
  data () {
    return {
    }
  },
  props: {
    company_name: String,
    telephone: String,
    pre_buffer: String,
    post_buffer: String,
    work_basic: String,
    work_time_unit: String,
    break_basic: String,
    post_work_break_flg: Boolean,
    use_project_break_flg: Boolean,
    slack_token: String,
    slack_channel: String,
    loading: Boolean,
  }
}
</script>

<style scoped>
.update-button-col {
  text-align: right;
  margin-right: 10px;
}
</style>
